// Canonical CMP design tokens (platform UI/UX polish pass, POL-006).
// Single source of truth — do not re-declare these hex values elsewhere;
// import from here (or use the matching tailwind `cpaGold` utilities).
export const commonStyles = {
  cpaGold: "#E1A731",
  cpaGoldDark: "#c78f1e",
  // Dark modal action buttons (members-modal value; unifies the former
  // #1F2937/#24272E drift — POL-006).
  charcoal: "#24272E",
  // Success/switch/status green. Checkboxes are NOT green — see Q-008.
  cmpGreen: "#10B981",
  // Manage Events "Live" status text / high-tier green. Deliberately a
  // distinct token from cmpGreen (screenshot-driven).
  liveGreen: "#16A34A",
  errorRed: "#d32f2f",
  fontSizes: {
    xlarge: 24,
    large: 20,
    medium: 16,
    small: 14,
  },
};
